import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IAlertListInfo } from '../models/IAlertInfo';
import { Module } from '../Module';
import { AlertTarget, GetAlertRequest, IGetAlertResult } from '../ServerApi/requests/GetAlertRequest';
import { GetUserAlertCountRequest, IGetUserAlertCountResult } from '../ServerApi/requests/GetUserAlertCountRequest';
import { GetUserAlertListRequest, IGetUserAlertListResult } from '../ServerApi/requests/GetUserAlertListRequest';
import { ServerService } from '../services/ServerService';

export class Alerts {

  public static $inject = [
    'ServerService'
  ];

  constructor(private ServerService: ServerService) {
  }

  public getCount(): ng.IPromise<number> {
    return this.ServerService.sendRequest(new GetUserAlertCountRequest())
      .then((result: IGetUserAlertCountResult) => {
        return result.totalCount;
      });
  }

  public getList(): ng.IPromise<IAlertListInfo> {
    return this.ServerService.sendRequest(new GetUserAlertListRequest())
      .then((result: IGetUserAlertListResult) => {
        return ServerApiMapper.alertList(result);
      });
  }

  public getForDatasource(id: string): ng.IPromise<IAlertListInfo> {
    return this.getForType(AlertTarget.datasource, id);
  }

  public getForWorkbook(id: string): ng.IPromise<IAlertListInfo> {
    return this.getForType(AlertTarget.workbook, id);
  }

  public getForType(type: string, id: string): ng.IPromise<IAlertListInfo> {
    return this.ServerService.sendRequest(new GetAlertRequest({
      targetType: type,
      targetId: id
    })).then((result: IGetAlertResult) => {
      return ServerApiMapper.alertList(result);
    });
  }

}

Module.instance().service('Alerts', Alerts);
